import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import { MaterialModule } from "app/material.module";
import { SharedModule } from "app/shared/shared.module";
import {
  DROPZONE_CONFIG,
  DropzoneConfigInterface,
  DropzoneModule,
} from "ngx-dropzone-wrapper";

import { PhotoUploadComponent } from "./photo-upload.component";

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  url: "",
  maxFilesize: 1,
  acceptedFiles: "image/jpeg,image/png", // Only JPG and PNG files accepted
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DropzoneModule,
    SharedModule,
    TranslateModule,
  ],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG,
    },
  ],
  declarations: [PhotoUploadComponent],
  exports: [PhotoUploadComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PhotoUploadModule {}
